module.exports = __webpack_public_path__ + "static/media/home_banner_welcome_es.176a01b1.svg";